module.exports = __webpack_public_path__ + "img/2-3.7e6a799.png";